import { supabase } from '@/supabaseClient'

function normalizeDidList(didNumber, didNumbers) {
  if (Array.isArray(didNumbers) && didNumbers.length > 0) {
    return [...new Set(didNumbers.map((d) => String(d).replace(/\D/g, '')).filter(Boolean))]
  }
  if (didNumber) {
    return [String(didNumber).replace(/\D/g, '')].filter(Boolean)
  }
  return []
}

/**
 * Checkout Stripe para contratar DID(s) via BRDID (mesmo fluxo do onboarding WABA).
 * O webhook chama POST adquirir_novo_did para cada número e grava em whatsapp_numbers.
 *
 * @see https://brdid.com.br/api-docs/#/did/adquirir_novo_did
 * @param {Object} params
 * @param {string} params.profileId
 * @param {string} [params.didNumber] — um número (compatível com onboarding)
 * @param {string[]} [params.didNumbers] — vários números (carrinho Voice)
 * @param {string} [params.success_path]
 * @param {string} [params.cancel_path]
 */
export async function createWhatsappNumberCheckout({
  profileId,
  didNumber,
  didNumbers,
  success_path = '/numeros?checkout=success',
  cancel_path = '/numeros?checkout=canceled',
}) {
  const list = normalizeDidList(didNumber, didNumbers)
  if (!profileId || list.length === 0) {
    throw new Error('Informe ao menos um número válido.')
  }

  const { data, error } = await supabase.functions.invoke('create-stripe-checkout', {
    body: {
      kind: 'whatsapp_number',
      profile_id: profileId,
      did_numbers: list,
      success_path,
      cancel_path,
    },
  })

  if (error) {
    throw new Error(error.message || 'Erro ao criar checkout para o número.')
  }

  if (!data?.checkout_url) {
    throw new Error('URL de checkout não recebida.')
  }

  window.location.href = data.checkout_url
}
